import { HeaderNavigationItem } from '@/features/navigation/components/desktop-navigation/header-navigation-item';
import type { Navigation } from '@/features/navigation/types/navigation';
import { clsx } from 'clsx';
import { useTranslations } from 'next-intl';

const EMPTY_NAVIGATION_ITEM: Navigation[] = [
  {
    id: 0,
    title: '',
    children: [],
    href: undefined,
  },
];

const getNavigationItemsWithoutChildren = (
  items: Navigation[] | undefined,
  numberOfElementsInMoreDropdown: number | null,
): Navigation[] => {
  if (
    !items ||
    !numberOfElementsInMoreDropdown ||
    numberOfElementsInMoreDropdown < 0
  )
    return [];
  const moreElements = [...items].slice(-numberOfElementsInMoreDropdown);

  return moreElements.map((item) => ({
    ...item,
    children: [],
  }));
};

interface Props {
  depthLevel: number;
  className?: string;
  numberOfOverflowingElements: number | null;
  data: Navigation[] | undefined;
  isInitialOverflowHidden: boolean;
}

export const MoreNavigationItem = ({
  depthLevel,
  data,
  numberOfOverflowingElements,
  isInitialOverflowHidden,
}: Props) => {
  const t = useTranslations('navigation');

  const hideClassName = isInitialOverflowHidden
    ? 'pointer-events-none invisible opacity-0'
    : 'pointer-events-none invisible hidden opacity-0';
  const showClassName = isInitialOverflowHidden
    ? '!pointer-events-auto !visible !opacity-100'
    : '!pointer-events-auto !visible !block !opacity-100';

  return (
    <HeaderNavigationItem
      key="more"
      depthLevel={depthLevel}
      data-id="more-navigation-item"
      aria-hidden={!numberOfOverflowingElements}
      item={{
        id: 0,
        title: t('more'),
        children: !numberOfOverflowingElements
          ? EMPTY_NAVIGATION_ITEM
          : getNavigationItemsWithoutChildren(
              data,
              numberOfOverflowingElements,
            ),
        href: undefined,
      }}
      className={clsx(
        'pointer-events-none invisible opacity-0',
        numberOfOverflowingElements && numberOfOverflowingElements > 0
          ? showClassName
          : hideClassName,
      )}
    />
  );
};
